// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem__AnswerItem--3-Y69","success":"AnswerItem__success--2SAC1","error":"AnswerItem__error--1KUj4"};